module.exports = __webpack_public_path__ + "static/media/40_B.2b2fe800.png";